<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Cota</span>
          <vs-input
            size="large"
            class="w-full"
            name="Cota"
            id="Cota"
            v-model="formCadastro.cota"
            v-validate="{ required: true }"
            :state="validateState('Cota')"
            :danger="validateClass('Cota')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Valor Inicial</span>
          <money
            class="w-full vs-inputx vs-input--input large"
            name="Valor Inicial"
            id="Valor Inicial"
            v-model="formCadastro.valorInicial"
            v-validate="{ required: true }"
            :state="validateState('Valor Inicial')"
            :danger="validateClass('Valor Inicial')"
            v-bind="money"
          ></money>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Valor Final</span>
          <money
            class="w-full vs-inputx vs-input--input large"
            name="Valor Final"
            id="Valor Final"
            v-model="formCadastro.valorFinal"
            v-validate="{ required: true }"
            :state="validateState('Valor Final')"
            :danger="validateClass('Valor Final')"
            v-bind="money"
          ></money>
        </div>
      </div>

      <div v-if="dados.exibeCilindrada == true" class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Cilindrada Inicial</span>
          <vs-input
            type="number"
            size="large"
            class="w-full"
            name="Cilindrada Inicial"
            id="Cilindrada Inicial"
            v-model="formCadastro.cilindradaInicial"
            v-validate="{ required: true }"
            :state="validateState('Cilindrada Inicial')"
            :danger="validateClass('Cilindrada Inicial')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div v-if="dados.exibeCilindrada == true" class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Cilindrada Final</span>
          <vs-input
            type="number"
            size="large"
            class="w-full"
            name="Cilindrada Final"
            id="Cilindrada Final"
            v-model="formCadastro.cilindradaFinal"
            v-validate="{ required: true }"
            :state="validateState('Cilindrada Final')"
            :danger="validateClass('Cilindrada Final')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idTabelaValor == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>

    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';
import { Money } from 'v-money';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  watch: {
    dados(value) {
      this.preencheForm();
    },
  },
  data() {
    return {
      money: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 2,
      },
      peso: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 3,
      },
      aguardeCadastro: false,
      idEmpresa: null,
      languages: lang,
      funcoesValicao: null,
      formCadastro: {
        idTabelaValor: null,
        idTabela: null,
        cota: null,
        valorInicial: 0,
        valorFinal: 0,
        cilindradaInicial: null,
        cilindradaFinal: null,
        status: true,
      },
    };
  },

  methods: {
    preencheForm() {
      if (this.dados.idTabelaValor) {
        this.formCadastro.idTabelaValor = this.dados.idTabelaValor;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.formCadastro.idTabela = this.dados.idTabela;
        this.formCadastro.cota = this.dados.cota;
        this.formCadastro.valorInicial = this.dados.valorInicial;
        this.formCadastro.valorFinal = this.dados.valorFinal;
        this.formCadastro.cilindradaInicial = this.dados.cilindradaInicial;
        this.formCadastro.cilindradaFinal = this.dados.cilindradaFinal;
        this.$forceUpdate();
      } else {
        this.resetForm();
        this.formCadastro.idTabela = this.dados.idTabela;
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    onSubmit() {
      this.formCadastro.idEmpresa = this.idEmpresa;

      var action = 'Atualizar';
      var msgRetorno = 'Dados Atualizados com sucesso';
      if (!this.formCadastro.idTabelaValor) {
        action = 'Adicionar';
        msgRetorno = `Registro Adicionado com sucesso`;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service
            .post('TabelaValores', action, this.formCadastro)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('concluido');
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        }
      });
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
      });
    },

    resetForm() {
      this.formCadastro = {
        idTabelaValor: null,
        idTabela: null,
        cota: null,
        valorInicial: null,
        valorFinal: null,
        cilindradaInicial: null,
        cilindradaFinal: null,
        status: true,
      };
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
  },
  mounted() {
    //this.buscaDadosSelects("domUf", "estados", "nomeUf", "codUf");
    //this.buscaDadosSelects("domMunicipio", "cidades", "nomeCidade", "idCidade");
    this.$validator.localize('ptBr', locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    Money,
    'v-select': vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
